var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'vidjet-radio-button',
    { toggle: _vm.variant === 'toggle', normal: _vm.variant === 'normal' },
    { 'force-flex': _vm.forceFlex && _vm.isChecked },
  ]},[_c('input',{class:[{ isChecked: _vm.isChecked }],attrs:{"id":_vm.id,"type":"radio","name":_vm.name,"disabled":_vm.disabled},domProps:{"value":_vm.val,"checked":_vm.isChecked},on:{"change":function($event){return _vm.$emit('input', _vm.val)}}}),_c('label',{class:[{ isChecked: _vm.isChecked }],attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }